module.exports = __webpack_public_path__ + "media/11_18.1a104f76.wav";